import { initializeApp } from 'firebase/app';
import { getToken } from 'firebase/messaging';
import { getMessaging } from 'firebase/messaging/sw';

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY as string,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN as string,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID as string,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET as string,
    messagingSenderId: process.env.VUE_APP_FIREBASE_SENDER_ID as string,
    appId: process.env.VUE_APP_FIREBASE_APP_ID as string,
};

const cloudMessagingPermission = (
    saveTokenCallback: (token: string) => void,
    permissionGranted?: (isGranded: boolean) => void,
) => {
    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            const app = initializeApp(firebaseConfig);
            const messaging = getMessaging(app);
            permissionGranted(true);

            getToken(messaging, {
                vapidKey: process.env.VUE_APP_FIREBASE_CLOUD_MESSAGING,
            })
                .then((currentToken) => {
                    if (currentToken) {
                        saveTokenCallback(currentToken);
                    } else {
                        console.log('Can not get token');
                    }
                })
                .catch((err) => {
                    throw err;
                });
        } else {
            permissionGranted(false);
        }
    });
};

export default cloudMessagingPermission;
